export default "__VITE_ASSET__BVOm4gfi__"